import React, { useEffect, useState } from 'react';
import { FormElement, FormSelector, FormLabel, FormInput, FormNumberInput, DragHandle } from "../components/StyledElements";
import { Handle, Position } from '@xyflow/react';
import { NodeCard } from './NodeCard';
import { CloseButton } from '../components/CloseButton';

export const GenerateQuestionsNodeCard = ({ onAdd = () => { }, style = {} }) => {
  return (
    <NodeCard title="Generate Questions" description="Generate questions that could be answered by the incoming text" onAdd={() => {
      onAdd(400, 500)
    }} style={style} />
  )
};

export const GenerateQuestionsNode = ({ id, data }) => {
  console.log("!!! LLM NODE DATA: ", data);
  const [localData, setLocalData] = useState();

  useEffect(() => {
    console.log("!!!MODEL: ", data.model);
    if (!data) {
      return;
    }
    setLocalData({
      useSecondaryEndpoint: data.useSecondaryEndpoint || false,
      model: data.model || "Agentwire-GPT-4o",
      questionCount: data.questionCount || 10,
      questionContext: data.questionContext || "",
    });
  }, [data]);

  return (
    <div style={{ display: "flex", flexDirection: "column", padding: "10px", border: "1px solid var(--main-border-color)", borderRadius: "8px", backgroundColor: "var(--content-item-bg)" }}>
      <CloseButton onClick={() => {
        data.onDelete(id);
      }} />
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <DragHandle />
        <FormLabel label="Generate Questions" />
        <FormElement>
          <FormLabel label="Use Secondary Endpoint" />
          <FormSelector
            value={localData?.useSecondaryEndpoint || false}
            onChange={(e) => {
              setLocalData({ ...localData, useSecondaryEndpoint: e.target.value === "true" });
              data.onUpdateData(id, { useSecondaryEndpoint: e.target.value === "true" });
            }}
            options={[
              { value: "false", label: "No" },
              { value: "true", label: "Yes" },
            ]}
          />
        </FormElement>
        <FormElement>
          <FormLabel label="Model" />
          <FormInput
            placeholder="Enter model name (e.g., gpt-3.5-turbo)"
            value={localData?.model || "Agentwire-GPT-4o"}
            onChange={(e) => {
              console.log("!!! METHOD CHANGE: ", e.target.value);
              setLocalData({ ...localData, model: e.target.value });
              data.onUpdateData(id, { model: e.target.value });
            }}
          />
        </FormElement>
        <FormElement>
          <FormLabel label="Question Count" />
          <FormNumberInput
            value={localData?.questionCount || 10}
            onChange={(e) => {
              setLocalData({ ...localData, questionCount: e.target.value });
              data.onUpdateData(id, { questionCount: e.target.value });
            }}
            min={1}
            step={1}
          />
        </FormElement>
        <FormElement>
          <FormLabel label="Question Context" />
          <FormInput
            as="textarea"
            rows={3}
            placeholder="Enter context for question generation"
            value={localData?.questionContext || ""}
            onChange={(e) => {
              setLocalData({ ...localData, questionContext: e.target.value });
              data.onUpdateData(id, { questionContext: e.target.value });
            }}
            style={{ width: "100%", fontFamily: "monospace" }}
          />
        </FormElement>
      </div>
      <Handle type="target" position={Position.Left} style={{ height: "12px", width: "12px" }} />
      <Handle type="source" position={Position.Right} style={{ height: "12px", width: "12px" }} id="questions" />
    </div>
  );
};

export default GenerateQuestionsNode;

